<template>
  <a-modal
    :visible="visible"
    :width="500"
    title="新增联系人"
    :footer="null"
    @cancel="$emit('cancel')"
  >
    <a-spin :spinning="spinning">
      <a-form :form="form" v-bind="formItemLayout" @submit="handlePost">
        <a-form-item label="联系人" extra="请输入真实的联系人姓名">
          <a-textarea
            v-decorator="['name', { rules: [{ required: true, message: '请输入联系人' }] }]"
            autoSize
          ></a-textarea>
        </a-form-item>
        <a-form-item label="营业地址"  extra="请输入真实的营业地址（营业执照上面的地址）">
          <a-textarea
            v-decorator="['address', { rules: [{ required: true, message: '请输入营业地址' }] }]"
            autoSize
          ></a-textarea>
        </a-form-item>

        <a-form-item label="联系人号码" extra="请输入真实的联系人号码">
          <a-input
            v-decorator="[
              'phone_number',
              { rules: [{ required: true, message: '请输入正确的手机号码', len: 11 }] },
            ]"
            autoSize
          ></a-input>
        </a-form-item>
        <a-form-item label="邮箱地址" extra="请输入真实的邮箱地址">
          <a-input
            v-decorator="[
              'email',
              { rules: [{ required: true, message: '请输入邮箱地址', type: 'email' }] },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 14, offset: 6 }">
          <a-button class="mr-6" type="primary" size="default" html-type="submit"> 提交</a-button>
          <a-button size="default" @click="$emit('cancel')">取消</a-button></a-form-item
        >
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
  import { contact_save } from '@/api/contact';
  export default {
    props: {
      visible: Boolean,
      ggb: String,
      taxNumber: String,
    },
    data() {
      return {
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 14 },
        },
        form: this.$form.createForm(this, { name: 'contact' }),
        info: {},
        spinning: false,
        loading: false,
      };
    },
    async mounted() {},
    watch: {
      async visible(a) {
        if (a) {
          setTimeout(() => this.form.resetFields(), 1);
          this.info = {};
        }
      },
    },
    methods: {
      async handlePost(e) {
        e.preventDefault();
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            if (!/^1\d{10}$/.test(values.phone_number)) {
              this.$message.error('请输入正确的手机号码');
              return;
            }
            try {
              this.spinning = true;
              let data = Object.assign(this.info, values);
              data.ggb = this.ggb;
              data.taxNumber = this.taxNumber;
              console.log(data);
              await contact_save(data);
              this.$emit('ok', data);
            } catch (error) {
              this.$error({ title: '错误提示', content: error });
            } finally {
              this.$emit('cancel');
              this.spinning = false;
            }
          } else {
            console.log(values);
          }
        });
      },
    },
  };
</script>
<style scoped lang="less">
  :deep(.ant-row) {
    position: static;
  }
</style>
